import { useState } from "react";

import { useLazySearchLocationsQuery } from "@store/services/SearchService";

interface ILocations {
  results: Array<Record<string, string>>;
  isLoading: boolean;
}

const useSearch = () => {
  const [searchLocations] = useLazySearchLocationsQuery();

  const [locations, setLocations] = useState<ILocations>({
    results: [],
    isLoading: false,
  });

  const locationSearch = async (query: string) => {
    if (query) {
      setLocations((prev) => ({ ...prev, isLoading: true }));

      const { data } = await searchLocations("");

      const results = (data?.auto_complete_items ?? []).filter((el) =>
        el.name.toLowerCase().startsWith(query.toLowerCase()),
      );

      setLocations({
        results,
        isLoading: false,
      });
    }
  };

  const locationReset = () => setLocations((prev) => ({ ...prev, results: [] }));

  return {
    locations,
    searchHandlers: { locationSearch },
    resetHandlers: { locationReset },
  };
};

export default useSearch;
